module.exports = __webpack_public_path__ + "img/fi-rr-shopping-cart.4a98aa6b.svg";